import MyStorage from '@/utils/cache';
import Logo from '@/assets/logo.png'

const state = {
  platformTitle: '黔好运云能源平台',
  platformLogo: Logo,
  platformIco: 'favicon.ico'
};

// 设置网站图标
function setIco(ico) {
  let linkTag = document.createElement('link');
  linkTag.rel = 'icon';
  linkTag.href = ico;
  document.head.appendChild(linkTag);
}

const mutations = {
  CHANGE_CONFIG: (state, data) => {
    const keys = Object.keys(data) || [];
    keys.forEach((key) => {
      if (state.hasOwnProperty(key) && data[key]) {
        state[key] = data[key];
        key === 'platformIco' && setIco(data[key]);
      }
    });
  }
};

const actions = {
  changeConfig({ commit }, data) {
    commit('CHANGE_CONFIG', data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
